import Client 
//  { showSessionExpiredModal }
 from '../../../utils/ClientVOIM';
import { ACTION_TYPES } from '../../../utils/Constants';
import { RESPONSE_CONSTANT } from '../../../utils/ResponseConstant';
import URL, { IM_STUDENT } from '../../../utils/URL';
import { myLog } from '../../../utils/Utility';
// import { domainConfigurations } from '../../../utils/common/DomainConfiguration';

// ---------- DASHBOARD ACTIONS - ADMINS ---------- //
// Super Admin, Level 1, Level 2
export function getLevelOneAdminSummary(callBack) {
    return function (dispatch) {
        Client.get(URL.LEVEL_ONE_ADMIN.DASHBOARD, null, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====DashDetails error===????', error);
                callBack(false);
            });
    };
}

// Super Admin, Level 1, level 2
export function getLevelById(id, callBack) {
    return function (dispatch) {
        Client.get(`${URL.LEVEL_ONE_ADMIN.GET_LEVEL}/${id}`, null, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====DashDetails error===????', error);
                callBack(false);
            });
    };
}

//  ---------- LIST ACTIONS ---------- //
// Super Admin, Level 1, Level 2
export const getTopLevelList = (values, callBack) => {
    return function (dispatch) {
        Client.get(URL.INS_SUPER_ADMIN.TOP_LEVEL, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.INS_SUPER_ADMIN.TOP_LEVEL_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};
// dashboard details report
// Super Admin, Level 1, Level 2,level 3
export const getLevelReports = (values, callBack) => {
    return function () {
        Client.get(URL.INS_SUPER_ADMIN.DASHOARD_LEVEL_REPORTS, values, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                callBack(false);
            });
    };
};

// ---------- ADD LEVEL ACTIONS ---------- //
// Super Admin, Level 1, Level 2
export const addLevel = (values, callBack) => {
    return function (dispatch) {
        Client.post(URL.INS_SUPER_ADMIN.TOP_LEVEL, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.INS_SUPER_ADMIN.INSTITUTION_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};

// ---------- UPDATE SECOND LEVELS ACTIONS ---------- //
// Super Admin, Level 1,
export const updateLevelTwo = (values, callBack) => {
    return function (dispatch) {
        Client.put(URL.LEVEL_ONE_ADMIN.ADD_SECOND_LEVEL, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.INS_SUPER_ADMIN.INSTITUTION_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};

export const passwordConfirmation = (values, callBack) => {
    return function () {
        Client.get(`${URL.INS_SUPER_ADMIN.PASSWORD_CONFIRM}/${values.password}`, null, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====Password confirmation Error===????', error);
                callBack(false);
            });
    };
};

export const updatePasswordConfirmation = (values, callBack) => {
    return function () {
        Client.put(`${URL.BRANCH_ADMIN.UPDATE_STUDENT_PASSWORD}`, values, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====Password confirmation Error===????', error);
                callBack(false);
            });
    };
};

export const getPayoutStatus = (callBack) => {
    return function () {
        Client.get(URL.INS_SUPER_ADMIN.PAYOUT_STATUS, null, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====payout status Error===????', error);
                callBack(false);
            });
    };
};

// ---------- STUDENTS LIST ACTIONS - ADMINS ---------- //
// Super Admin, Level 1, Level 2
export const getAdminStudentsList = (id, value, callBack) => {
    return function (dispatch) {
        Client.get(`${URL.INS_SUPER_ADMIN.STUDENTS_LEVEL}${id}`, value, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.INS_SUPER_ADMIN.STUDENTS_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                callBack(false);
            });
    };
};

// financial Reports api for super admin, level 1, level 2, level 3
export const getFinancialReport = (value, callBack) => {
    return function (dispatch) {
        Client.get(URL.INS_SUPER_ADMIN.FINANCIAL_REPORT, value, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.INS_SUPER_ADMIN.STUDENTS_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                callBack(false);
            });
    };
};

// Below are Except Super Admin
// ---------- UPDATING LEVEL STATUS ----------
// Level 1, Level 2
export const updateLevelStatus = (id, data, callBack) => {
    const values = {
        id,
        status: data,
    };
    return function (dispatch) {
        Client.put(`${URL.LEVEL_ONE_ADMIN.ACTIVATELEVEL}`, values, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};

// below are Except Super Admin and Level 1 Admin
// level 2 and level 3
// Create User Action
export const createUser = (values, callBack) => {
    return function (dispatch) {
        Client.post(URL.BRANCH_ADMIN.CREATEUSER, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.INS_SUPER_ADMIN.INSTITUTION_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};

// Edit User Action
export const editUser = (values, callBack) => {
    return function (dispatch) {
        Client.put(URL.BRANCH_ADMIN.UPDATEUSER, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.INS_SUPER_ADMIN.INSTITUTION_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};

//
export const getExpertiseLevel = (callBack) => {
    return function (dispatch) {
        Client.get(`${URL.BRANCH_ADMIN.GET_EXPERTISE_LEVEL}`, null, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.BRANCH_ADMIN.GET_EXPERTISE_LEVEL,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};

// Subject List Action
export const getSubCategoryList = (values, callBack) => {
    return function (dispatch) {
        Client.get(URL.BRANCH_ADMIN.GET_SUB_CATEGORY, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.BRANCH_ADMIN.GET_SUBJECT_LIST,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};

//
export const getTutorById = (id, callBack) => {
    return function (dispatch) {
        Client.get(`${URL.BRANCH_ADMIN.GET_USER}/${id}`, null, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.BRANCH_ADMIN.GET_STUDENT,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};

// Bulk Upload
export const bulkBatchEducatorUpload = (value, type, callBack) => {
    return function (dispatch) {
        Client.post(
            `${URL.BRANCH_ADMIN.BULK_BATCH_UPLOAD_EDUCATOR}?typeOfUser=${type}`,
            value,
            true
        )
            .then((response) => {
                myLog('====Educator upload response===::::', response.response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====Educator upload error===????', error);
                callBack(false);
            });
    };
};

//
export const bulkBatchEducatorUploadStatus = (values, callBack) => {
    return function (dispatch) {
        Client.get(`${URL.BRANCH_ADMIN.BULK_BATCH_UPLOAD_STATUS}`, values, true)
            .then((response) => {
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    callBack(response);
                    dispatch({
                        type: ACTION_TYPES.BRANCH_ADMIN.GET_STATUS,
                        payload: response.response,
                    });
                } else {
                    callBack(false);
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};

export const bulkBatchStudentUpload = (value, type, callBack) => {
    return function (dispatch) {
        Client.post(`${URL.BRANCH_ADMIN.BULK_BATCH_UPLOAD_STUDENTS}?activeStatus=1`, value, true)
            .then((response) => {
                myLog('====Educator upload response===::::', response.response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====Educator upload error===????', error);
                callBack(false);
            });
    };
};

//
export const bulkBatchStudentUploadStatus = (values, callBack) => {
    return function (dispatch) {
        Client.get(`${URL.BRANCH_ADMIN.BULK_BATCH_UPLOAD_STATUS_STUDENTS}`, values, true)
            .then((response) => {
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    callBack(response);
                    dispatch({
                        type: ACTION_TYPES.BRANCH_ADMIN.GET_STATUS,
                        payload: response.response,
                    });
                } else {
                    callBack(false);
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};
//
export const updateUserStatus = (values, callBack) => {
    return function (dispatch) {
        Client.put(URL.COMMON_ENDPOINT.ACTIVATEUSER, values, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};

//
export const getStudent = (id, callBack) => {
    return function (dispatch) {
        Client.get(`${URL.BRANCH_ADMIN.GET_USER}/${id}`, null, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.BRANCH_ADMIN.GET_STUDENT,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};

// session list
export const getFlaggedSessionList = (value, callBack) => {
    return function (dispatch) {
        Client.get(`${URL.BRANCH_ADMIN.GET_BRANCH_ADMIN_SESSSION_LIST}`, value, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====Flagged Session List error===????', error);
                callBack(false);
            });
    };
};

// Below are Except Super Admin, Level 1 & Level 2
export function getPhysicianAvailability(id, date, callBack) {
    const searchParams = new URLSearchParams(window.location.search);
    let payload = {};
    if (searchParams.get('studentUserId')) {
        payload = {
            studentUserId: searchParams.get('studentUserId'),
        };
    }
    return function (dispatch) {
        Client.get(
            `${URL.BRANCH_ADMIN.GET_PHYSICIAN_AVAILABILITY}${id}/date/${date}`,
            payload,
            true
        )
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.PATIENT.GET_PHYSICIAN_AVAILABILITY,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                if (typeof callBack === 'function') {
                    callBack(false);
                }
            });
    };
}

export function getEducatorAvailability(id, date, callBack, options = {}) {
    const searchParams = new URLSearchParams(window.location.search);
    let payload = {};
    if (searchParams.get('studentUserId')) {
        payload = {
            studentUserId: searchParams.get('studentUserId'),
        };
    }
    return function (dispatch) {
        const isEdit = options?.isEdit === true;
        const url = `${URL.PHYSICIAN.GET_EDUCATOR_AVAILABILITY}${date}${
            isEdit ? '?isEdit=true' : ''
        }`;

        Client.get(url, payload, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.PATIENT.GET_PHYSICIAN_AVAILABILITY,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                if (typeof callBack === 'function') {
                    callBack(false);
                }
            });
    };
}

//
export const appointmentBook = (data, callback) => {
    return function (dispatch) {
        Client.post(URL.BRANCH_ADMIN.APPOINTMENT_BOOKING, data, true)
            .then((response) => {
                myLog('====appointment booking response===::::', response.response);
                callback(response);
            })
            .catch((error) => {
                myLog('===appointment booking error===????', error);
            });
    };
};

// reschedule session
export function rescheduleSession(values, callBack) {
    return function () {
        Client.put(URL.IM_EDUCATOR.RESCHEDULE_SESSION, values, true)
            .then((response) => {
                myLog('====rescheduleSession response===::::', response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====rescheduleSession error===????', error);
                callBack(false);
            });
    };
}

// session cancel
export function sessionAppointmentCancel(values, callBack) {
    return function () {
        Client.DELETENEW(URL.IM_EDUCATOR.CANCELATION_REQUEST_APPONTMENT_SESSION_LIST, values, true)
            .then((response) => {
                myLog('====sessionAppointmentCancel response===::::', response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====sessionAppointmentCancel error===????', error);
                callBack(false);
            });
    };
}

//
export function getVisitInformation(visitId, callBack) {
    return (dispatch) => {
        Client.get(`${URL.IM_EDUCATOR.GET_VISIT_INFORMATON}/${visitId}`, null, true)
            .then((response) => {
                myLog('====getVisitInformation Action response===::::', response);
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.GET_VISIT_INFORMATION,
                        payload: response.response,
                    });
                    // Dispatch whiteboard state from server response
                    const whiteboardResVO = response.response?.whiteboardResVO;
                    if (whiteboardResVO) {
                        dispatch({
                            type: ACTION_TYPES.WHITE_BOARD_OPEN,
                            payload: {
                                isWhiteboardOpen: whiteboardResVO.isWhiteboardOpen || false,
                                sessionType: response.response?.sessionType || '',
                            },
                        });
                    }
                }
            })
            .catch((error) => {
                myLog('====getVisitInformation error===????', error);
                callBack(false);
            });
    };
}
export function getBroadcastInformation(sessionId, id, callBack) {
    return (dispatch) => {
        Client.get(
            `${URL.IM_EDUCATOR.GET_VISIT_INFORMATON}/${sessionId}?l3institutionId=${id}`,
            null,
            true
        )
            .then((response) => {
                myLog('====getVisitInformation Action response===::::', response);
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.GET_VISIT_INFORMATION,
                        payload: response.response,
                    });
                    // Dispatch whiteboard state from server response
                    const whiteboardResVO = response.response?.whiteboardResVO;
                    if (whiteboardResVO) {
                        dispatch({
                            type: ACTION_TYPES.WHITE_BOARD_OPEN,
                            payload: {
                                isWhiteboardOpen: whiteboardResVO.isWhiteboardOpen || false,
                                sessionType: response.response?.sessionType || '',
                            },
                        });
                    }
                }
            })
            .catch((error) => {
                myLog('====getVisitInformation error===????', error);
                callBack(false);
            });
    };
}
//
export const removeImageFromSession = (id, callBack) => {
    return function (dispatch) {
        Client.DELETE(`${URL.IM_EDUCATOR.REMOVE_IMAGES}/${id}`, null, true)
            .then((response) => {
                myLog('====attachment save response===::::', response.response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====attchment save error===????', error);
                callBack(false);
            });
    };
};

//
export const attachmentSave = (visitId, photo, callback) => {
    let data = {
        id: visitId,
        images: photo,
    };
    return function (dispatch) {
        Client.post(IM_STUDENT.ATTACHMENT_SAVE, data, true)
            .then((response) => {
                myLog('====attachment save response===::::', response.response);
                callback(response);
            })
            .catch((error) => {
                myLog('====attchment save error===????', error);
            });
    };
};

// Flag Status List
export function flagStatusListing(visitId, callBack) {
    return function () {
        Client.get(
            `${URL.BRANCH_ADMIN.GET_FLAGSESSION_STATUS}/${visitId}/flagging-status`,
            {},
            true
        )
            .then((response) => {
                myLog('====flagSessionCall response===::::', response);
                callBack(response);
            })
            .catch((error) => {
                myLog('====flagSessionCall error===????', error);
                callBack(false);
            });
    };
}

export const getBatchUploadHistory = (values, callBack) => {
    return function () {
        Client.get(URL.BRANCH_ADMIN.GET_BATCH_UPLOAD_HISTORY, values, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};

export function getSubjectReferralSummary(id, callBack) {
    return (dispatch) => {
        Client.get(`${URL.IM_EDUCATOR.GET_SUBJECT_REFERRAL_SUMMARY}/${id}`, null, true)
            .then((response) => {
                myLog('====getVisitInformation Action response===::::', response);
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.GET_VISIT_INFORMATION,
                        payload: response.response,
                    });
                    // Dispatch whiteboard state from server response
                    const whiteboardResVO = response.response?.whiteboardResVO;
                    if (whiteboardResVO) {
                        dispatch({
                            type: ACTION_TYPES.WHITE_BOARD_OPEN,
                            payload: {
                                isWhiteboardOpen: whiteboardResVO.isWhiteboardOpen || false,
                                sessionType: response.response?.sessionType || '',
                            },
                        });
                    }
                }
            })
            .catch((error) => {
                myLog('====getVisitInformation error===????', error);
                callBack(false);
            });
    };
}

export const getUnreadCounts = (callBack) => {
    return function () {
        Client.get(URL.COMMON_ENDPOINT.UNREAD_COUNTS, null, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                callBack(false);
            });
    };
};

// function get_domain() {
//     const domain = window.location.hostname;
//     const domainConfig = domainConfigurations.find((config) => config.domain === domain) || {};
//     return domainConfig.bloomIfAI_url;
// }

export function getUserById(userId, callBack) {
    return function (dispatch) {
        Client.get(`/api/v4/user/${userId}`, null, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.BRANCH_ADMIN.GET_STUDENT,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====getUserById error===????', error);
                callBack(false);
            });
    };
}
